import { withProps } from 'recompose';
import { GridLayout } from './layout';
import RadioGroup from './RadioGroup';

const GridRadioGroup = withProps({ groupComponent: GridLayout })(RadioGroup);

export default GridRadioGroup;
